<template>
  <Table
    ref="table"
    :layers-filters="layersFilters"
    @setLayerFeaturesFilters="setLayerFeaturesFilters"
    @deleteLayerFeaturesFilters="deleteLayerFeaturesFilters"
    :is-custom-layer="true"
    :custom-layer-data="customLayerData"
    :has-edit-buttons="true"
  >
    <template #additionalTools="{isAnyFeatureSelected}">
      <table-button
        v-if="billingSmsSendingEnabled"
        v-bind="sendSmsButton"
        @sendSms="openSendSmsDialog"
        :disabled="!isAnyFeatureSelected"
        :tooltip="getToolitp(isAnyFeatureSelected)"
      >
      </table-button>
    </template>
    <template #dialogs>
      <main-input-dialog
        v-if="isSmsDialogLoaded"
        :is-visible.sync="isSmsDialogVisible"
        :inputs="smsDialogInputs"
        agree-text="button.send"
        dialog-width="40%"
        :title-translation="$i18n.t('dialog.title.sendSms')"
        :loading="isSmsButtonLoading"
        @agree="sendSmsHandler"
      >
        <template #messageText.input="slot">
          <v-col>
            <v-row no-gutters>
              <v-col cols="12">
                <data-input
                  class="textarea--custom"
                  v-model="messageText"
                  v-bind="slot"
                  :rules="slot.rules"
                ></data-input>
              </v-col>
            </v-row>
          </v-col>
        </template>
        >
      </main-input-dialog>
    </template>
  </Table>
</template>

<script>
import { get, call, sync } from 'vuex-pathify';

import Table from '@/components/Table.vue';
import TableButton from '@/components/TableButton';
import DataInput from '@/components/DataInput';

export default {
  name: 'TableWatermeters',
  components: {
    Table,
    DataInput,
    TableButton,
    MainInputDialog: () => import('@/components/MainInputDialog'),
  },
  data: () => ({
    sendSmsButton: {
      name: 'sendSms',
      icon: 'mdi-cellphone-message',
      fontSize: '20px',
    },
    isSmsDialogLoaded: false,
    isSmsDialogVisible: false,
    isSmsButtonLoading: false,
    messageText: undefined,
  }),
  computed: {
    activeTool: sync('tools/activeTool'),
    currentLayerSelectedFeatures: get('map/selectedFeatures@:watermetersLayerId'),
    layersFilters: get('layers/layersFilters'),
    watermetersLayerId: get('admin/modulesMapping@billing.layer_id'),
    billingSmsSendingEnabled: get('admin/settingsValues@billing_sms_sending_enabled'),
    customLayerData() {
      const watermetersRouteNames = {
        waterDissolutionWatermeters: 'waterDissolutionWatermetersInfo',
        waterDissolutionWatermetersInfo: 'waterDissolutionWatermetersInfo',
        legalization: 'legalizationInfo',
        legalizationInfo: 'legalizationInfo',
        billingAnomalyDetection: 'billingAnomalyDetectionInfo',
        billingAnomalyDetectionInfo: 'billingAnomalyDetectionInfo',
      };
      return {
        routeName: watermetersRouteNames[this.$route.name] || 'layerFeature',
        eventName: 'toggleWatermeters',
        filterEventName: 'toggleWatermetersFilter',
        layerId: this.watermetersLayerId,
      };
    },
    smsDialogInputs() {
      return [
        {
          name: 'messageText',
          translationPath: 'dialog.body.messageText',
          subtitle: 'dialog.body.messageTextSubtitle',
          cols: '12',
          dataType: {
            name: 'textarea',
          },
          rows: 1,
          autoGrow: true,
          rules: [v => !!v || v === undefined || 'rules.required'],
        },
      ];
    },
  },
  methods: {
    sendSms: call('billings/sendSms'),
    deleteLayerFeaturesFilters(currentLayerId) {
      this.$store.set('layers/DELETE_LAYERS_FILTERS!', currentLayerId);
    },
    setLayerFeaturesFilters(filter) {
      this.$store.set('layers/SET_LAYERS_FILTERS!', filter);
    },
    getToolitp(isAnyFeatureSelected) {
      return isAnyFeatureSelected
        ? this.$i18n.t('button.sendSms')
        : this.$i18n.t('button.toSendSms', { suffix: this.$i18n.t('button.atLeastOneSelected') });
    },
    openSendSmsDialog() {
      this.isSmsDialogLoaded = true;
      this.isSmsDialogVisible = true;
    },
    async sendSmsHandler() {
      try {
        this.isSmsButtonLoading = true;
        await this.sendSms({
          watermeter_ids: this.currentLayerSelectedFeatures,
          message_text: this.messageText,
        });
        this.isSmsDialogVisible = false;
      } catch (error) {
        console.log('~ error', error);
      }
      this.isSmsButtonLoading = false;
    },
  },
  mounted() {
    this.$once('hook:beforeDestroy', () => {
      this.$nextTick(() => {
        this.activeTool = undefined;
      });
      this.$root.$emit('toggleWatermeters', false);
    });
  },
};
</script>

<style lang="scss">
.textarea--custom {
  textarea {
    max-height: 400px;
  }
}
</style>
